import axios from 'axios';
 import { Toast } from '@nutui/nutui';
// import XLSX from 'xlsx';
 const sAxios = axios.create();
sAxios.defaults.timeout = 30000;


let urls =  'https://its.shwfl.edu.cn/'
sAxios.defaults.baseURL = urls; // 本地
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};
const errorHandler = (error) => {
  const { response } = error;

  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    // const { status, url } = response;
    const { status } = response;
 Toast.fail( `请求错误 ${status},${errorText}`,{ 
  duration:1000,
});
  } else if (!response) {
    Toast.fail( '您的网络发生异常，无法连接服务器',{ 
      duration:1000,
    });
    
  }

  return response;
};

export const requests = (action = 'get', url, data = {}, config) =>{
const toast =  Toast.loading( `Loading...`,{ 
  duration:3000
} )
  return new Promise((resolve, reject) => {
    sAxios
      .request({
        method: action,
        url,
        data,
        ...config,
      })
      .then((res) => {
        resolve(res);
        toast.hide()
      })
      .catch((err) => {
        toast.hide()
        errorHandler(err);
         reject(err);
      });
  })
}
;
export function get(url, param = {}, config) {
  console.log(url, param, config);
  return requests('get', url, undefined, {
    param,
    ...config,
  });
}
export function post(url, param = {}, config) {
  return requests('post', url, param, config);
}
export function put(url, param = {}, config) {
  return requests('put', url, param, config);
}
export function deletes(url, param = {}, config) {
  return requests('delete', url, undefined, {
    param,
    ...config,
  });
}
export const postLogin = (url, data = {}, config) =>
  new Promise((resolve, reject) => {
    sAxios
      .request({
        method: 'post',
        url,
        data,
        ...config,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        errorHandler(err);
        // reject(err);
      });
  });



// WEBPACK FOOTER //
// ./src/utils/ajax.js